<mat-toolbar color="accent">
  @if (data.isPublishing) {
    <h2>Publish Custom Report</h2>
  } @else {
    <h2>{{ data.customReport ? 'Edit' : 'Save' }} Custom Report</h2>
  }
</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content class="text-black">
    <div class="flex flex-col gap-4">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" required cdkFocusInitial />
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description"></textarea>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Restrict Access</mat-label>
        <mat-select
          formControlName="restrictAccessTo"
          multiple
          [compareWith]="compareAccessFn"
        >
          <mat-optgroup label="Roles">
            @for (role of roles$ | async; track role.ref.id) {
              <mat-option [value]="role">
                {{ role.name }}
              </mat-option>
            }
          </mat-optgroup>

          <mat-optgroup label="Staff">
            @for (staffer of staff$ | async; track staffer.ref.id) {
              <mat-option [value]="staffer">
                {{ staffer.name }}
              </mat-option>
            }
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    @if (data.customReport && !data.isPublishing) {
      <button type="button" mat-stroked-button color="warn" (click)="delete()">
        Delete
      </button>
    }
    @if (data.customReport && !data.isPublishing) {
      <button
        type="button"
        mat-stroked-button
        color="warn"
        (click)="changeTemplate()"
      >
        Change Template
      </button>
    }
    <span class="flex grow"></span>
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button type="submit" mat-flat-button color="primary">Save</button>
  </mat-dialog-actions>
</form>
